module.exports = __webpack_public_path__ + "static/img/main.da5dc06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/16/main.png
// module id = 2YF6
// module chunks = 1